var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "button",
    {
      staticClass: "help-btn",
      attrs: { type: "button", "aria-label": "Open tutorial", title: "Help" },
      on: {
        click: function ($event) {
          return _vm.$emit("triggerTutorial")
        },
      },
    },
    [_c("span", { staticClass: "help-btn-label" }, [_vm._v("Help?")])]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }